import { $themeConfig } from '@theme-config' // TODO move this to hw-ui
import hwUiMenuItems from '@hw-ui/store/states/menu-items'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed, // TODO change to collapsed, and create an isCollapsed getter
    activeMenuItems: hwUiMenuItems.vertical,
    menuItems: {
      'hw-ui': hwUiMenuItems,
    }
  },
  getters: {},
  mutations: {
   /**
   * set active menu items
   * @param {object} value - information about app and layout
   * @param {string} value.app - the root path
   * @param {string} value.layout - layout e.g 'vertical', 'horizontal', or 'full'
   */
    SET_ACTIVE_MENU_ITEMS(state, {app, layout}) {
      state.activeMenuItems = state.menuItems[app || 'hw-ui'][layout || 'vertical']
    },
    SET_MENU_ITEMS(state, menuItems) {
      state.menuItems = {...state.menuItems, ...menuItems}
    },
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
  },
  actions: {},
}
